const isEmptyString = (payload = "") => {
    return payload.length === 0
}

export default isEmptyString
